import { createPopper } from '@popperjs/core';

$(function() {
    if ($('.hrg-ce-image-map').length === 0) return;

    // Unterhalb von lg steht der Text unter dem Bild, darüber als Popover am Punkt
    const mobileQuery = window.matchMedia('(max-width: 991.98px)');

    $('.hrg-ce-image-map').each(function() {
        const map = this;
        const markers = map.querySelectorAll('.image-map-marker');
        const contents = map.querySelectorAll('.image-map-content');
        const hint = map.querySelector('.image-map-hint');
        const panel = map.querySelector('.image-map-panel');

        let popper = null;

        const getActiveMarker = function() {
            return map.querySelector('.image-map-marker.is-active');
        };

        const destroyPopper = function() {
            if (!popper) return;

            // Inline-Styles von Popper entfernen, damit der Text mobil wieder im Fluss steht
            const content = popper.state.elements.popper;
            popper.destroy();
            popper = null;
            content.removeAttribute('style');
            content.removeAttribute('data-popper-placement');
            content.querySelector('.image-map-arrow').removeAttribute('style');
        };

        const createMarkerPopper = function(marker, content) {
            destroyPopper();
            if (mobileQuery.matches) return;

            popper = createPopper(marker, content, {
                placement: 'top',
                modifiers: [
                    { name: 'offset', options: { offset: [0, 14] } },
                    { name: 'flip', options: { fallbackPlacements: ['bottom', 'right', 'left'] } },
                    { name: 'preventOverflow', options: { padding: 10 } },
                    { name: 'arrow', options: { padding: 12 } },
                ],
            });
        };

        const close = function() {
            destroyPopper();
            markers.forEach(function(marker) {
                marker.classList.remove('is-active');
                marker.setAttribute('aria-expanded', 'false');
            });
            contents.forEach(function(content) {
                content.hidden = true;
            });
            hint.hidden = false;
        };

        markers.forEach(function(marker) {
            marker.addEventListener('click', function() {
                const isActive = marker.classList.contains('is-active');
                close();
                if (isActive) return;

                const content = map.querySelector('#' + marker.getAttribute('aria-controls'));
                if (!content) return;

                marker.classList.add('is-active');
                marker.setAttribute('aria-expanded', 'true');
                content.hidden = false;
                hint.hidden = true;

                if (mobileQuery.matches) {
                    panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                } else {
                    createMarkerPopper(marker, content);
                }
            });
        });

        map.querySelectorAll('.image-map-close').forEach(function(button) {
            button.addEventListener('click', function() {
                const marker = getActiveMarker();
                close();
                if (marker) marker.focus();
            });
        });

        // Beim Wechsel zwischen Mobil und Desktop das offene Popover umschalten
        mobileQuery.addEventListener('change', function() {
            const marker = getActiveMarker();
            if (!marker) return;

            createMarkerPopper(marker, map.querySelector('#' + marker.getAttribute('aria-controls')));
        });

        document.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape') return;

            const marker = getActiveMarker();
            if (!marker) return;

            close();
            marker.focus();
        });

        // Klick außerhalb schließt das Popover (nur Desktop, mobil bleibt der Text stehen)
        document.addEventListener('click', function(event) {
            if (mobileQuery.matches || !getActiveMarker()) return;
            if (map.contains(event.target) && event.target.closest('.image-map-marker, .image-map-content')) return;

            close();
        });
    });
});
